import {
  Slot
} from "../../../chunk-5DWHOSR4.mjs";
import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-CD4FQC4X.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/IconTile/IconTile.tsx
import { jsx } from "react/jsx-runtime";
var iconTileVariants = cva("buyscout-icon-tile", {
  variants: {
    size: {
      sm: "buyscout-icon-tile--size-sm",
      md: "buyscout-icon-tile--size-md"
    },
    tone: {
      neutral: "buyscout-icon-tile--tone-neutral",
      gold: "buyscout-icon-tile--tone-gold",
      info: "buyscout-icon-tile--tone-info",
      success: "buyscout-icon-tile--tone-success",
      warning: "buyscout-icon-tile--tone-warning"
    },
    shape: {
      rounded: "buyscout-icon-tile--shape-rounded",
      circle: "buyscout-icon-tile--shape-circle"
    }
  },
  defaultVariants: {
    size: "md",
    tone: "neutral",
    shape: "rounded"
  }
});
function IconTile({
  ref,
  ...props
}) {
  const { size, tone, shape, asChild = false, className, children, ...rest } = props;
  const Comp = asChild ? Slot : "span";
  const classes = iconTileVariants({ size, tone, shape, className });
  return /* @__PURE__ */ jsx(Comp, { ref, className: classes, ...rest, children });
}
IconTile.displayName = "IconTile";
export {
  IconTile
};
//# sourceMappingURL=IconTile.mjs.map